import queryString from "query-string";
import { useEffect, useState } from "react";
import { getServiceabilityList, uploadServiceabilityFile } from "../../../core/actionCreators/servicebilityActionCreators";
import { GET_SERVICEABILITY_DEFAULT_SIZE } from "../../../utils/constants";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import Loader from "../Loader/Loader";
import ServiceabilityListItem from "./ServiceabilityListItem";
import { downloadServiceabilityService } from "../../../core/services/serviceabilityService";
import { useDispatch } from "react-redux";
import { convertJsonToCsv, removeEmptyStringKeys } from "../../../utils/helper";
import CommonPagination from "../CommonPagination/CommonPagination";
import FileDownloadLineIcon from "remixicon-react/FileDownloadLineIcon";
import ServiceabilityCreateModal from "./ServiceabilityCreateModal";

const EMPTY_FILTERS = {
    msn: "",
    categoryCode: "",
    isCod: "",
    isServiceable: "",
    zipcode: "",
}

const ServiceabilityList = () => {
    const dispatch = useDispatch()

    const { serviceabilityData, isLoading } = useSelector((s: any) => s.serviceabilityStore)

    const { user } = useSelector((s: any) => s.authStore)

    const [file, setFile] = useState("")
    const [isDownloading, setIsDownloading] = useState(false)
    const [showCreateModal, setShowCreateModal] = useState(false)

    // `filters` is what the user is typing; `searchCriteria` is what has actually
    // been searched for. Only Search / Clear / pagination move one into the other.
    const [filters, setFilters] = useState({ ...EMPTY_FILTERS } as any)
    const [searchCriteria, setSearchCriteria] = useState({
        ...EMPTY_FILTERS,
        pageNumber: 0,
        pageSize: GET_SERVICEABILITY_DEFAULT_SIZE,
    } as any)

    useEffect(() => {
        dispatch(getServiceabilityList(queryString.stringify(removeEmptyStringKeys(searchCriteria)), null));
    }, [searchCriteria, dispatch]);

    const onSearch = () => {
        setSearchCriteria({ ...searchCriteria, ...filters, pageNumber: 0 })
    }

    const onFilterKeyDown = (e: any) => {
        if (e.key === "Enter") onSearch()
    }

    const onPageChange = (pageNumber: any) => {
        setSearchCriteria({ ...searchCriteria, pageNumber: pageNumber })
    }

    const hasActiveFilters = Object.keys(EMPTY_FILTERS).some((key) => !!filters[key] || !!searchCriteria[key])

    const clearFilters = () => {
        setFilters({ ...EMPTY_FILTERS })
        setSearchCriteria({ ...searchCriteria, ...EMPTY_FILTERS, pageNumber: 0 })
    }

    // Exports every row matching the filters currently applied to the listing —
    // pagination is deliberately dropped so the file is not just the visible page.
    const downloadFilteredData = async () => {
        setIsDownloading(true)
        try {
            const { pageNumber, pageSize, ...filterCriteria } = searchCriteria
            const response: any = await downloadServiceabilityService(
                queryString.stringify(removeEmptyStringKeys(filterCriteria))
            )

            // A failed download still resolves — the error body arrives as a JSON blob.
            if (response.data?.type?.includes("json")) {
                const errorText = await response.data.text()
                toast.error(JSON.parse(errorText)?.statusDescription || "Failed to download file.")
                return
            }

            const url = window.URL.createObjectURL(new Blob([response.data], { type: "text/csv" }))
            const link = document.createElement("a")
            link.href = url
            link.setAttribute("download", `serviceability-${new Date().toISOString().slice(0, 10)}.csv`)
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(url)
            toast.success("Downloaded successfully.")
        }
        catch (err: any) {
            console.log("downloadFilteredData: exceptionError: ", err)
            toast.error("Failed to download file.")
        }
        finally {
            setIsDownloading(false)
        }
    }

    const fileHandler = (e: any) => {
        if (e.target.files && e.target.files[0]) {
            let file = e.target.files[0];
            setFile(file)
        }
    }

    const bulkUploadHandler = () => {
        if (!file) {
            toast.error("Please select file.")
            return
        }
        const formData = new FormData()
        formData.append("file", file)
        dispatch(uploadServiceabilityFile({
            param: `email=${user.email || "deepak.singh1@moglix.com"}`,
            data: formData
        }, (d: any) => {
            toast.success("Uploaded successfully.")
            // window.location.reload()
        }))
    }

    const downloadServiceabilityFile = () => {
        const data = [
            { msn: 'MSN2RCODZ5NY9R', zipcode: "201301", isCod: "FALSE", categoryCode: "-1", isServiceable: "TRUE" }
        ];
        convertJsonToCsv(data, 'sample.csv')
    }

    return (
        <>
            <div className="p-4 flex">
                <p className="text-xl font-bold text-[#43425D] w-1/5">SERVICEABILITY</p>
                <div className="flex items-center w-4/5 ml-auto justify-end">
                    {/* <div className="flex items-center h-9 mr-4 w-[120px]">
                        <input
                            className="w-4 h-4 rounded border  border-[#3c3c3c] px-2.5 outline-none "
                            type="radio"
                            value={"true"}
                        />
                        <span className="ml-2 text-[#3c3c3c] text-sm font-medium">
                            MSN
                        </span>
                    </div>
                    <div className="flex items-center h-9 mr-4 w-[160px]">
                        <input
                            className="w-4 h-4 rounded border  border-[#3c3c3c] px-2.5 outline-none "
                            type="radio"
                            value={"true"}
                        />
                        <span className="ml-2 text-[#3c3c3c] text-sm font-medium">
                            CATEGORY
                        </span>
                    </div> */}
                    <button
                        type="button"
                        onClick={downloadServiceabilityFile}
                        title="Download a sample CSV showing the columns required for bulk upload"
                        className="flex items-center gap-1 mr-4 text-xs font-medium text-blue-500 hover:text-blue-700 hover:underline whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 rounded"
                    >
                        <FileDownloadLineIcon size={14} />
                        Download Sample File
                    </button>
                    <input onChange={(e) => fileHandler(e)} type="file" title="Select the filled CSV to bulk upload" className="border border-gray-300 py-2 rounded focus: outline-none px-1.5 text-xs w-1/4" />
                    <button
                        type="button"
                        onClick={bulkUploadHandler}
                        className="h-9 px-4 bg-blue-500 text-white text-sm font-semibold rounded shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 ml-4 inline-flex items-center justify-center"
                    >
                        Bulk Upload
                    </button>
                    <button
                        type="button"
                        onClick={() => setShowCreateModal(true)}
                        className="h-9 px-4 bg-blue-500 text-white text-sm font-semibold rounded shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75 ml-3 inline-flex items-center justify-center"
                    >
                        Create
                    </button>
                </div>
            </div>
            <div className="mt-2.5 bg-white px-4 py-3 flex flex-wrap items-end gap-x-4 gap-y-3">
                <div className="w-[220px]">
                    <label className="block text-[11px] text-gray-600 mb-1">Msn</label>
                    <input type="text" placeholder="Search MSN" value={filters.msn} onChange={(e) => setFilters({ ...filters, msn: e.target.value })} onKeyDown={onFilterKeyDown} className="border border-gray-300 h-8 rounded-sm focus:outline-none focus:border-blue-400 px-1.5 text-xs w-full" />
                </div>
                <div className="w-[140px]">
                    <label className="block text-[11px] text-gray-600 mb-1">Category</label>
                    <input type="text" placeholder="Category code" value={filters.categoryCode} onChange={(e) => setFilters({ ...filters, categoryCode: e.target.value })} onKeyDown={onFilterKeyDown} className="border border-gray-300 h-8 rounded-sm focus:outline-none focus:border-blue-400 px-1.5 text-xs w-full" />
                </div>
                <div className="w-[140px]">
                    <label className="block text-[11px] text-gray-600 mb-1">ZipCode</label>
                    <input type="text" placeholder="Zipcode" value={filters.zipcode} onChange={(e) => setFilters({ ...filters, zipcode: e.target.value })} onKeyDown={onFilterKeyDown} className="border border-gray-300 h-8 rounded-sm focus:outline-none focus:border-blue-400 px-1.5 text-xs w-full" />
                </div>
                <div className="w-[140px]">
                    <label className="block text-[11px] text-gray-600 mb-1">Status</label>
                    <select value={filters.isServiceable} onChange={(e) => setFilters({ ...filters, isServiceable: e.target.value })} className="bg-white border border-gray-300 h-8 w-full focus:outline-none focus:border-blue-400 px-1.5 rounded-sm text-xs">
                        <option value=''>All</option>
                        <option value='true'>Serviceable</option>
                        <option value='false'>Not Serviceable</option>
                    </select>
                </div>
                <div className="w-[140px]">
                    <label className="block text-[11px] text-gray-600 mb-1">Payment</label>
                    <select value={filters.isCod} onChange={(e) => setFilters({ ...filters, isCod: e.target.value })} className="bg-white border border-gray-300 h-8 w-full focus:outline-none focus:border-blue-400 px-1.5 rounded-sm text-xs">
                        <option value=''>All</option>
                        <option value='true'>COD</option>
                        <option value='false'>Prepaid</option>
                    </select>
                </div>
                <button
                    onClick={onSearch}
                    className="h-8 px-5 rounded text-xs font-semibold bg-blue-500 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-75"
                >
                    Search
                </button>
                <button
                    onClick={clearFilters}
                    disabled={!hasActiveFilters}
                    className="h-8 px-4 rounded text-xs font-medium bg-gray-200 text-gray-700 hover:bg-gray-300 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                    Clear Filters
                </button>
                <button
                    onClick={downloadFilteredData}
                    disabled={isDownloading}
                    title="Download all rows matching the applied filters"
                    className="h-8 px-4 ml-auto rounded text-xs font-medium border border-blue-500 text-blue-600 bg-white hover:bg-blue-50 disabled:opacity-40 disabled:cursor-not-allowed"
                >
                    {isDownloading ? "Downloading..." : "Download CSV"}
                </button>
            </div>
            <div className="mt-2.5 campaign-list bg-white mb-[54px]">
                <table className="w-full">
                    <thead className="bg-[#343434]">
                        <tr>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[12%]">Msn</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[10%]">Category</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[10%]">ZipCode</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[12%]">Serviceable</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[8%]">Payment</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[14%]">Created At</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[14%]">Updated At</th>
                            <th className="px-4 py-3 text-left text-xs font-semibold text-white w-[20%]">History</th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? <Loader /> : <ServiceabilityListItem data={serviceabilityData?.data || []} />}
                    </tbody>
                </table>
            </div>
            {serviceabilityData?.data && <CommonPagination data={serviceabilityData} PAGE_SIZE={GET_SERVICEABILITY_DEFAULT_SIZE} onPageChange={onPageChange} />}
            <ServiceabilityCreateModal
                visible={showCreateModal}
                onClose={() => setShowCreateModal(false)}
                onSuccess={() => {
                    dispatch(getServiceabilityList(queryString.stringify(removeEmptyStringKeys(searchCriteria)), null));
                }}
            />
        </>
    )
}
export default ServiceabilityList;